import moment from 'moment/moment';

export const toLocalMoment = (v) => {
  if (!v) return null;

  if (/[zZ]|[+\-]\d{2}:\d{2}$/.test(v)) {
    return moment.parseZone(v)
  }

  return moment.utc(v);
}
